/* Discovery funnel scroll animations: staggered reveals, price count-up + strike,
   parallax photo bands. No-JS and prefers-reduced-motion get the static page. */
(() => {
  'use strict';

  const root = document.querySelector('.dfn');
  if (!root) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // arms the hidden initial states in CSS; without JS nothing is ever hidden
  root.classList.add('dfn--animate');

  // --- staggered reveals ---
  root.querySelectorAll('[data-reveal-group]').forEach((group) => {
    Array.from(group.children).forEach((child, i) => {
      child.setAttribute('data-reveal', '');
      child.style.transitionDelay = Math.min(i * 90, 540) + 'ms';
    });
  });
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
  );
  root.querySelectorAll('[data-reveal]').forEach((el) => revealObserver.observe(el));

  // --- price anchor: count up, strike through, pop the offer price ---
  root.querySelectorAll('[data-countup]').forEach((el) => {
    const target = parseInt(el.textContent.replace(/[^0-9]/g, ''), 10);
    if (!target) return;
    el.textContent = '$0';
    const counter = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        counter.disconnect();
        const start = performance.now();
        const DURATION = 1400;
        const step = (now) => {
          const t = Math.min(1, (now - start) / DURATION);
          const eased = 1 - Math.pow(1 - t, 3);
          el.textContent = '$' + Math.round(target * eased).toLocaleString('en-US');
          if (t < 1) {
            requestAnimationFrame(step);
          } else {
            el.classList.add('is-struck');
            const pop = el.parentElement.querySelector('[data-pop]');
            if (pop) setTimeout(() => pop.classList.add('is-popped'), 350);
          }
        };
        requestAnimationFrame(step);
      },
      { threshold: 0.6 }
    );
    counter.observe(el);
  });

  // --- parallax photo bands ---
  const bands = Array.from(root.querySelectorAll('[data-parallax] img'));
  if (bands.length) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      bands.forEach((img) => {
        const rect = img.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        const progress = (rect.top + rect.height) / (vh + rect.height); // 1 entering → 0 leaving
        img.style.transform = 'translateY(' + ((progress - 0.5) * -12).toFixed(2) + '%)';
      });
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }
})();
